
const primaryColor = '#f05423';
const analogRed = '#f0234c';
const secondaryColor = '#478D00';

const Styles = {
    borderCard: {
        borderWidth: 1,
        borderColor: '#BBBBBB',
        borderRadius: 5,
        padding: 15,
        marginBottom: 15
    },

    positiveTag: {
        padding: 7,
        backgroundColor: '#90EE9C',
        color: '#008A04',
        fontSize: 15,
        borderRadius: 10,
        fontWeight: 'bold'
    },

    //BASE COLOR: B4F245
    lightPositiveTag: {
        padding: 7,
        backgroundColor: '#D5FA97',
        color: '#529C00',
        fontSize: 15,
        borderRadius: 10,
        fontWeight: 'bold'
    },

    neutralTag: {
        padding: 7,
        backgroundColor: '#CCCCCC',
        color: '#555555',
        fontSize: 15,
        borderRadius: 10,
        fontWeight: 'bold'
    },

    negativeTag: {
        padding: 7,
        backgroundColor: '#FF9F9A',
        color: '#DD0D02',
        fontSize: 15,
        borderRadius: 10,
        fontWeight: 'bold'
    },

    //BASE COLOR: F9FE48
    lightWarningTag: {
        padding: 7,
        backgroundColor: '#FAFE6D',
        color: '#828800',
        fontSize: 15,
        borderRadius: 10,
        fontWeight: 'bold'
    },

    warningTag: {
        padding: 7,
        backgroundColor: '#FFDF9A',
        color: '#CC7601',
        fontSize: 15,
        borderRadius: 10,
        fontWeight: 'bold'
    },

    infoTag: {
        padding: 7,
        backgroundColor: '#8ADBE2',
        color: '#037C87',
        fontSize: 15,
        borderRadius: 10,
        fontWeight: 'bold'
    },

    //BASE COLOR: 6948C6
    infoTagAlt: {
        padding: 7,
        backgroundColor: '#AC96E8',
        color: '#4E2BB7',
        fontSize: 15,
        borderRadius: 10,
        fontWeight: 'bold'
    },

    sasCard: {
        backgroundColor: 'white',
        marginBottom: 15,
        borderRadius: 5,
        padding: 15,
        elevation: 5,
        border: '1px solid #444444',
        boxShadow: '0 10px 80px 0 rgba(0, 0, 0, 0.2), 0 40px 50px 0 rgba(0, 0, 0, 0.19)',
    },

    sasAlternateCard: {
        backgroundColor: 'white',
        marginBottom: 15,
        padding: 15,
        elevation: 1
    },

    horizontalPadding: {
        paddingLeft: 15,
        paddingRight: 15
    },

    sasPadding: {
        padding: 15,
    },

    sasMargin: {
        margin: 15,
    },

    selectedTabBorder: {
        borderBottom: '5px solid ' + primaryColor,
        borderBottomColor: primaryColor,
        borderBottomWidth: 5
    },

    btnSuccess: {
        backgroundColor: primaryColor,
        padding: 10,
        paddingLeft: 13,
        paddingRight: 13,
        paddingBottom: 10,
        borderRadius: 16
    },

    btnSuccessCompact: {
        paddingTop: 5,
        paddingLeft: 7,
        paddingRight: 7,
        paddingBottom: 5,
        borderRadius: 8,
        backgroundColor: primaryColor
    },

    btnWarning: {
        backgroundColor: '#FF9F49',
        paddingTop: 10,
        paddingLeft: 13,
        paddingRight: 13,
        paddingBottom: 10,
    },

    btnDanger: {
        backgroundColor: '#FF5249',
        paddingTop: 10,
        paddingLeft: 13,
        paddingRight: 13,
        paddingBottom: 10,
        borderRadius: 16
    },

    btnDefault: {
        borderColor: primaryColor,
        borderWidth: 1,
        paddingTop: 10,
        paddingLeft: 13,
        paddingRight: 13,
        paddingBottom: 10,
        borderRadius: 16,
        backgroundColor: 'white'
    },

    btnDarkCompact: {
        backgroundColor: '#404040',
        paddingTop: 5,
        paddingLeft: 7,
        paddingRight: 7,
        paddingBottom: 5,
        borderRadius: 8,
    },

    btnDefaultCompact: {
        borderColor: '#404040',
        borderWidth: 1,
        paddingTop: 5,
        paddingLeft: 7,
        paddingRight: 7,
        paddingBottom: 5,
        borderRadius: 8,
        backgroundColor: 'white'
    },

    btnInvisible: {
        paddingTop: 10,
        paddingLeft: 13,
        paddingRight: 13,
        paddingBottom: 10,
        borderRadius: 16
    },

    btnSuccessDisabled: {
        backgroundColor: primaryColor,
        paddingTop: 10,
        paddingLeft: 13,
        paddingRight: 13,
        paddingBottom: 10,
        opacity: .5,
        borderRadius: 16
    },

    elevation: {
        elevation: 6,
        shadowColor: '#404040',
    },

    flexDirectionRow: {
        flexDirection: 'row',
    },

    flexEqualWidth: {
        flex: 1,
    },

    borderTopDivider: {
        borderTopColor: '#DDDDDD',
        borderTopWidth: 1
    },

    borderBottomDivider: {
        borderBottomColor: '#DDDDDD',
        borderBottomWidth: 1
    },

    iconPadding: {
        paddingTop: 15,
        paddingBottom: 15,
        paddingLeft: 10,
        paddingRight: 10
    },

    textColor: {
        color: '#404040'
    },

    themeInputBorder: {
        borderBottomWidth: 2,
        borderBottomColor: primaryColor
    },

    secondaryThemeInputBorder: {
        borderBottomWidth: 1,
        borderBottomColor: 'rgba(69,127,129,1)',
    },

    selectedThemeColor: {
        color: '#58CFD9'
    },

    basicColor: {
        color: analogRed
    },

    basicBackgroundColor: {
        color: analogRed
    },

    standardColor: {
        color: '#e69f36'
    },

    standardBackgroundColor: {
        color: '#ff9a30'
    },

    themeColor: {
        color: primaryColor
    },

    themeSecondaryColor: {
        color: secondaryColor
    },

    themeBackgroundColor: {
        backgroundColor: primaryColor,
    },

    themeComplementaryColor: {
        color: '#2A4FB3'
    },

    redColor: {
        color: '#d71f37'
    },

    sasWideElement: {
        alignSelf: 'stretch',
    },

    fontBig: {
        fontSize: 20
    },

    rotate90: {
        transform: [{ rotate: '90deg' }]
    },

    headerIcons: {
        paddingTop: 13,
        paddingRight: 9,
        paddingBottom: 13,
        paddingLeft: 9
    },

    notificationTitle: {
        fontSize: 18,
        fontWeight: 'bold'
    },

    notificationContent: {
        fontSize: 14,
    },

    commentProfileImage: {
        width: 38,
        height: 38,
        marginTop: 12,
        borderRadius: 19
    },

    directReplyContainer: {
        backgroundColor: 'rgba(71, 104, 195, .17)',
        padding: 8,
        marginBottom: 7,
        borderRadius: 16
    },

    grayBackground: {
        backgroundColor: '#DDDDDD',
        borderRadius: 10,
        padding: 15
    },
};

export default Styles;